import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { useHistory, useParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { InputMask } from "primereact/inputmask";
import { FileUpload } from 'primereact/fileupload';
import { Image } from "primereact/image";
import { showToast } from "../ToastManager";
import ProfileService from "../../service/ProfileService";
import UsuarioService from "../../service/UsuarioService";
import ImageService from "../../service/ImageService";

import Utils from "../../utilities/Utils";

const profileService = new ProfileService(); // Create an instance of LojaService
const usuarioService = new UsuarioService();
const imageService = new ImageService();

const PerfilUsuario = () => {
    const history = useHistory();
    const iss = localStorage.getItem('iss');
    const profile = JSON.parse(localStorage.getItem('profile'));

    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [selectedGender, setSelectedGender] = useState(null);
    const [avatar, setAvatar] = useState()
    const [uploadFile, setUploadFile] = useState()
    const [novoPerfil, setNovoPerfil] = useState(profile)
    const [perfil, setPerfil] = useState(profile)
    const fileUploadRef = useRef(null);

    const { id } = useParams();

    const gender = ['MASCULINO', 'FEMININO', 'OUTRO']

    useEffect(() => {
        if (perfil && perfil.profile) {
            setNovoPerfil(perfil.profile)
            var img = perfil.profile.images.find(img => img.image_type_id === 1)
            setAvatar(img.url);
            var gender;
            if (perfil.profile.gender === 'MALE') gender = 'MASCULINO'
            if (perfil.profile.gender === 'FEMALE') gender = 'FEMININO'
            if (perfil.profile.gender === 'OTHER') gender = 'OUTRO'
            setSelectedGender(gender)
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    /* const initTipoUsuario = () => {
        setLoading(true);
        perfilService.listAllTipoUsuario(iss).then(data => {
            const updatedItems = data.data.rows.map(({ descricao, ativo, createdAt, updatedAt, ...rest }) => rest);
            setTipoUsuario(updatedItems);
            setLoading(false);
        });
    } */

    const onUpload = (e) => {
        setLoading1(true);

        const imageData = new FormData();
        imageData.append('file', e.files[0]);
        imageData.append("profile_id", perfil.id)
        imageData.append("image_type_id", 1)
        imageData.append("caption", `Avatar ${perfil.username}`)
        setUploadFile(imageData)

        fileUploadRef.current.clear();

        setAvatar(e.files[0].objectURL);
        setLoading1(false);
    }

    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';

        if (checkbox) {
            val = e.checked;
        }

        if (name === 'gender') {
            setSelectedGender(e.value)
            if (e.value === 'MASCULINO') val = 'MALE'
            if (e.value === 'FEMININO') val = 'FEMALE'
            if (e.value === 'OUTRO') val = 'OTHER'
            // val = e.value.id;
        }

        if (name === 'cpf') {
            let c = String(val).replace(/[^\d]/g, '')
            if (c.length == 11 && !Utils.validateCPF(c)) {
                showToast({ severity: 'error', summary: 'Error', detail: 'CPF inválido' });
                return;
            }

            val = Utils.formatCnpj(val);
        }

        let _perfil = { ...novoPerfil };
        // Verifica se o nome tem um ponto
        if (name.includes('.')) {
            const [parent, child] = name.split('.'); // Divide o nome em pai e filho
            if (!_perfil[parent]) {
                _perfil[parent] = {}; // Cria o objeto pai se não existir
            }
            _perfil[parent][child] = val; // Define o valor do atributo filho
        } else {
            if (list) {
                _perfil[name] = val;
            } else {
                _perfil[name] = val; // Define o valor diretamente se não houver aninhamento
            }

        }

        setNovoPerfil(_perfil);

    }

    const cadastrar = async () => {
        setSubmitted(true);
        if (novoPerfil.cpf && novoPerfil.name) {
            novoPerfil.cpf = String(novoPerfil.cpf).replace(/[^\d]/g, '')
            let { status, profile, companiesRoles, ..._perfil } = novoPerfil;

            setLoading(true)

            if (uploadFile) {
                await imageService.uploadAvatar(iss, uploadFile).then(data => {
                    showToast({ severity: 'info', summary: 'Upload', detail: 'Imagem enviada com sucesso', life: 3000 });
                    perfil.profile.images[0].url = data.data.url;
                    localStorage.setItem('profile', JSON.stringify(perfil));
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro upload', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            }

            await profileService.putProfile(iss, novoPerfil.id, _perfil).then(data => {
                showToast({ severity: 'success', summary: 'Cadastro de perfil', detail: 'Perfil atualizado com sucesso' });
                perfil.profile = novoPerfil;
                localStorage.setItem('profile', JSON.stringify(perfil));
                history.push('/');
                return;

            }, error => {
                var msg = error.response.data ?? error.response.data.error.message
                showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: msg.message });
            }).finally(() => { setLoading(false) });
        }
    }

    const verificaSeExisteCPF = async (e) => {
        let val = (e.target && e.target.value) || '';

        const cpfLimpo = String(val).replace(/[^\d]/g, '');

        if (cpfLimpo.length === 11) {
            try {
                setLoading(true);
                const search = `cpf=${cpfLimpo}`;
                const data = await usuarioService.getUserFilter(iss, search);

                if (data.data.count > 0) {
                    showToast({
                        severity: 'error',
                        summary: 'Conflito',
                        detail: 'CPF já cadastrado'
                    });
                    setNovoPerfil(prev => ({ ...prev, cpf: '' }));
                }
            } catch (error) {
                console.error('Erro ao verificar CPF:', error);
                showToast({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao verificar disponibilidade do CPF'
                });
            } finally {
                setLoading(false);
            }
        }
    };


    const handleKeyDown = (event, name) => {
        const { key } = event;
        const lastValue = novoPerfil[name] || '';
        let _perfil = { ...novoPerfil };
        if (key === 'Backspace') {
            const input = event.target;
            let cursorPos = input.selectionStart;
            if (cursorPos > 0 && (input.value[cursorPos - 1] === '.' || input.value[cursorPos - 1] === '-')) {
                event.preventDefault(); // Prevent default to manually handle backspace
                let newValue = lastValue.substring(0, cursorPos - 1) + lastValue.substring(cursorPos);
                newValue = newValue.replace(/\D/g, '');
                _perfil.cpf = Utils.formatCpf(newValue); // Apply mask after removal
                setNovoPerfil(_perfil);
            }
        }
    };

    return (
        <div className="grid">
            <h4>Perfil</h4>
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                            <div style={{
                                width: 160,
                                height: 160,
                                border: 'solid',
                                borderWidth: '0.5px',
                                borderRadius: '8px',
                                borderColor: 'rgba(255,255,255,0.35)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }} >
                                <Image src={avatar} alt="Image"
                                    width="150" height="auto" />
                            </div>
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                            <h5>Adicionar/Alterar</h5>
                            <FileUpload loading={loading1} ref={fileUploadRef} className="mr-2 mb-2"
                                chooseLabel={'Imagem'}
                                mode="basic"
                                name="avatar[]"
                                customUpload={true}
                                auto={true}
                                uploadHandler={onUpload} accept="image/*" maxFileSize={1000000} />
                            {/* <FileUpload name="image" url={avatar} onUpload={onUpload()} multiple accept="image/*" maxFileSize={1000000} /> */}
                        </div>
                    </div>
                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <InputText value={novoPerfil.name} onChange={(e) => onInputChange(e, 'name')}
                                    className={classNames({ 'p-invalid': submitted && !novoPerfil.name })} required id="name" type="text"
                                />
                                <label htmlFor="name">Nome</label>
                            </span>
                            {submitted && !novoPerfil.name && <small className="p-invalid">Nome é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-6">
                            <span className="p-float-label">
                                <InputMask
                                    onChange={(e) => { onInputChange(e, 'cpf'); }}
                                    onBlur={(e) => { verificaSeExisteCPF(e); }}
                                    onKeyDown={handleKeyDown}
                                    value={Utils.formatCpf(novoPerfil.cpf)}
                                    required
                                    className={classNames({ 'p-invalid': submitted && !novoPerfil.cpf })}
                                    id="cpf"
                                    type="text"
                                    mask={"999.999.999-99"}
                                    unmask={false}
                                />
                                <label htmlFor="cpf">CPF</label>
                            </span>
                            {submitted && !novoPerfil.cpf &&
                                <small className="p-invalid">CPF é obrigatório.</small>}

                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <Dropdown optionLabel="nome" value={selectedGender}
                                    className={classNames({ 'p-invalid': submitted && !novoPerfil.gender })}
                                    options={gender}
                                    onChange={(e) => {
                                        onInputChange(e, 'gender')
                                    }} />
                                <label htmlFor="gender">Gênero</label>
                            </span>

                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <InputMask value={novoPerfil.phone}
                                    mask={"(99) 9.9999-9999"}
                                    onChange={(e) => onInputChange(e, 'phone')}
                                    id="phone" type="text" />
                                <label htmlFor="phone">Telefone</label>
                            </span>
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-12">
                            <label htmlFor="bio">Escreva um pouco sobre você</label>
                            <InputTextarea id="bio" value={novoPerfil.bio} onChange={(e) => onInputChange(e, 'bio')} required rows={3} cols={20} />
                        </div>
                        {/* <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                                <span className="p-float-label">
                                    <InputMask value={perfil.data_nascimento} onChange={(e) => onInputChange(e, 'data_nascimento')}
                                        mask={"99/99/9999"} id="data_nascimento" type="text" />
                                    <label htmlFor="data_nascimento">Data Nascimento</label>
                                </span>
                            </div> */}

                        <Button label='Atualizar' loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        {/* <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(PerfilUsuario, comparisonFn);
